import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import TargetGroups from './pages/TargetGroups';
import GetInvolved from './pages/GetInvolved';
import ImpactStories from './pages/ImpactStories';
import Contact from './pages/Contact';

const App: React.FC = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header />
      <Box as="main" flex="1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/target-groups" element={<TargetGroups />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/impact-stories" element={<ImpactStories />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
};

export default App;
